import get from 'lodash/get';
import React from 'react';
import { Copy } from '../copy';
import { RegistrationFormGqlData, Variant } from '../interfaces/registration';
import loginVariants from '../login-variants';
import registrationVariants from '../registration-variants';

export const replaceInterpolatedVariables = (data: any, copy: Copy): Copy => {
  // This regex captures variables within {{ }}
  const regex = /{{[\w.-]+}}/gi;

  return Object.entries(copy).reduce((acc, [key, value]) => {
    // We don't expect to have falsy values, but just in case,
    // we can leave them untouched.
    // Leave React components as they are if their are any present in the variant.
    if (!value || React.isValidElement(value)) {
      return acc;
    }

    // Copy can have nested objects, and we want to replace
    // all strings, even deep in the object.
    if (typeof value === 'object') {
      return {
        ...acc,
        [key]: replaceInterpolatedVariables(data, value)
      };
    }

    const matches = value.match(regex);
    if (Array.isArray(matches)) {
      matches.forEach((match) => {
        // Extract the variable name from the squigglies.
        const capturedVariableName = match.slice(2, -2);

        const populatedField = get(data, capturedVariableName) || '';

        value = value.replace(match, populatedField);
      });
    }

    return {
      ...acc,
      [key]: value
    };
  }, copy);
};

export const getVariantFromQuery = (
  data?: RegistrationFormGqlData
): Variant => {
  // It's possible the variant might be expired, or have a typo or something.
  // Fall back to the default if no matching variant exists.
  let variant = registrationVariants.primary;

  if (data) {
    if (data.registrationFormData?.marketplace_app?.name) {
      variant = registrationVariants.marketplace;
    } else if (data.registrationFormData?.oauth_app?.name) {
      if (data.registrationFormData.oauth_app.is_internal) {
        variant = registrationVariants.community;
      } else {
        variant = registrationVariants.oauth_app;
      }
    } else if (data.registrationFormData.team) {
      variant = registrationVariants.team;
    }
  }

  return replaceInterpolatedVariables(data, variant) as Variant;
};

export const getRandomLoginVariant = () => {
  const variantKeys = Object.keys(loginVariants);
  const selectedVariant =
    variantKeys[Math.floor(Math.random() * variantKeys.length)];

  return loginVariants[selectedVariant];
};
